import collectionsConfig from './collections.config';

const {
  articlesArticle,
  articlesPage,
  articlesExternal,
} = collectionsConfig;

export interface IArticlesStatus {
  statusCode: number;
  statusMessage: string;
  message?: string;
}

export interface IArticlesConfig {
  prefix: string;
  fields: Array<string | object>;
  notFound: IArticlesStatus;
  archived: IArticlesStatus;
}

const articlesConfig: { [key: string]: IArticlesConfig } = {
  artikelen: {
    prefix: 'artikelen',
    fields: articlesArticle,
    notFound: {
      statusCode: 404,
      statusMessage: 'Artikel niet gevonden',
    },
    archived: {
      statusCode: 410,
      statusMessage: 'Artikel is gearchiveerd',
      message: 'Dit artikel is gearchiveerd en niet meer beschikbaar',
    },
  },
  paginas: {
    prefix: 'paginas',
    fields: articlesPage,
    notFound: {
      statusCode: 404,
      statusMessage: 'Pagina niet gevonden',
    },
    archived: {
      statusCode: 410,
      statusMessage: 'Pagina is gearchiveerd',
      message: 'Deze pagina is gearchiveerd en niet meer beschikbaar',
    },
  },
  'externe-link': {
    prefix: '',
    fields: articlesExternal,
    notFound: {
      statusCode: 404,
      statusMessage: 'Pagina niet gevonden',
    },
    archived: {
      statusCode: 410,
      statusMessage: 'Pagina is gearchiveerd',
      message: 'Deze pagina is gearchiveerd en niet meer beschikbaar',
    },
  },
};

export default articlesConfig;
